/**
 * Motion and emphasis for the Landmines accordion's fly-in strip and alerting
 * header. The same numbers are in `LandmineBarView.swift` (macOS) and the WPF
 * bar; change all three together.
 *
 * Entrance is a soft spring (eases to a stop, not a snap); exit is a slower
 * ease so the strip leaves gently.
 */
export const LANDMINE_BAR_MOTION = {
  enterMs: 550,
  /** Slight overshoot, the CSS stand-in for the macOS spring (response 0.55, damping 0.86). */
  enterEasing: 'cubic-bezier(0.22, 1.15, 0.36, 1)',
  holdMs: 3500,
  exitMs: 600,
  exitEasing: 'cubic-bezier(0.4, 0, 0.2, 1)',
  textCrossfadeMs: 250,
  headerFadeMs: 350,
  badgePulseMs: 400,
} as const;

/**
 * Solid red read as an error state beside the transcript. At 60% the header is
 * still unmistakable, but white text no longer has the contrast to sit on it,
 * so the alerting header uses the landmine palette's dark-red heading ink.
 */
export const LANDMINE_BAR_ALERTING_OPACITY = 0.6;
